import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/recordList/record/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_1ltsw_1",
  "main": "_main_1ltsw_10",
  "arrows": "_arrows_1ltsw_20",
  "input": "_input_1ltsw_24",
  "icon": "_icon_1ltsw_55",
  "iconBox": "_iconBox_1ltsw_59",
  "disabled": "_disabled_1ltsw_80"
};